import { Card, Tabs } from "antd";
import styled from "styled-components";

export const WrapperCard = styled(Card)`
  margin-top: 10px;
  min-height: 400px;
`;

export const WrapperTabNav = styled(Tabs)`
  overflow: auto;
  .ant-tabs-nav-wrap {
    justify-content: center;
  }
`;
